const APP_SERVICE_WORKER_URL = new URL(
  '/service-worker.js',
  window.location.origin
).href;


const isAppServiceWorker = (worker) =>
  worker && worker.scriptURL === APP_SERVICE_WORKER_URL;

const isAppCache = (cacheName) =>
  cacheName.includes('workbox') || cacheName.includes('precache');

/**
 * Remove the legacy app-shell worker without touching other service workers,
 * such as the push-notification worker at /sw.js.
 */
export async function unregisterAppServiceWorker() {
  if (!('serviceWorker' in navigator)) return;

  try {
    const registrations = await navigator.serviceWorker.getRegistrations();

    await Promise.all(
      registrations
        .filter((registration) =>
          [registration.active, registration.waiting, registration.installing].some(
            isAppServiceWorker
          )
        )
        .map((registration) => registration.unregister())
    );

    if ('caches' in window) {
      const cacheNames = await window.caches.keys();
      await Promise.all(
        cacheNames
          .filter(isAppCache)
          .map((cacheName) => window.caches.delete(cacheName))
      );
    }
  } catch (error) {
    // Cleanup must never prevent the application from starting.
    console.warn('Unable to clean up the app service worker:', error);
  }
}
